import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { SITE_LOG,RMTICKET_LOG,COMPLAINT_LOG } from "./type";

export const getSiteLog = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.getSiteLog}?site_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SITE_LOG, payload: data.response.data });
    return data.response.data;
  }
};

export const getRMTicketLog = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.maintenance.rmTicketLog}?rm_ticket_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: RMTICKET_LOG, payload: data.response.data });
    return data.response.data;
  }
};

export const getComplaintLog = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.maintenance.rmTicketLog}?complaint_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: COMPLAINT_LOG, payload: data.response.data });
    return data.response.data;
  }
};


